export default __webpack_public_path__ + "c8a4478404c485bc7bac89cefba50cd5.png";